export default __webpack_public_path__ + "static/media/successPattern.47dde3e6.svg";